<!--个人中心页面-->
<template>
  <div style="background-color: #f8f8f8">
    <div style="background-color: #f8f8f8;">
      <el-container
          style="
        position: relative;
        width: 1240px;
        height: 100%;
        margin: 0 auto;
        overflow: hidden;
      "
      >
        <div
            id="asideFixedMenu"
            ref="asideFixedMenu"
            class="has-vertical-scrollerbar"
            style="transition: all 0.2s; width: 200px;min-width: 200px;padding: 20px 0;"
        >
          <el-menu
              :collapse="isCollapsed"
              mode="vertical"
              :default-active="activeMenuIndex"
              active-text-color="##1890FF"
              :default-openeds="['1', '2', '3']"
              router
          >
            <el-submenu index="1">
              <template slot="title">
                <i class="el-icon-s-custom"></i>
                <span slot="title">{{ $T('个人中心') }}</span>
              </template>
              <el-menu-item index="/updateinfo">{{ $T('资料修改') }}</el-menu-item>
              <el-menu-item index="/isai-apply-list">{{ $T('我报名的赛事') }}</el-menu-item>
              <el-menu-item index="/spectator-orders">{{ $T('我的订单') }}</el-menu-item>
            </el-submenu>

 
          </el-menu>
        </div>
        <el-main>
          <keep-alive :include="keepAliveInclude">
            <router-view class="main-content">
            </router-view>
          </keep-alive>
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "MineIndex",
  components: {},
  data() {
    return {
      activeMenuIndex: '',
      activeIndex: "登录",
      inputusername: "", //用户名
      inputpassword: "", //密码
      inputmobilphone: "", //手机号码
      inputIdecode: "", //验证码
      inputpasswordagain: "", //再次输入密码
      getidecodeData: "获取验证码",
      inputdepartment: "",
      meta: {
        title: "",
        tabs: []
      },
      keepAlive: true,
      activeName: "",
      keepAliveInclude: this.$route.meta.keepAlive ? this.$route.name : "",
      keepAliveArray: this.$route.meta.keepAlive ? [this.$route.name] : [],

      isCollapsed: false,
      is_danwei: 1 //1单位 2个人
    };
  },
  watch: {
    '$route.path'(path) {
      this.syncActiveMenu(path);
    },
  },

  created() {
    this.syncActiveMenu(this.$route.path);
  },
  // beforeRouteEnter(to, from, next) {
  //   // console.log('beforeRouteEnter +activeMenuIndex', this.$route.path)
  //   next();
  // },
  mounted() {
    document.title = this.$T('个人中心')
    this.getUser();
  },
  methods: {
    syncActiveMenu(path) {
      if (path && path.indexOf('/spectator-orders') === 0) {
        this.activeMenuIndex = '/spectator-orders';
        return;
      }
      this.activeMenuIndex = path;
    },
    getUser() {
      let that = this;
      that.$api.post("/api/index/userdata", {}, r => {
        this.is_danwei = r.data.is_danwei;
      });
    },
    handleSelect(val) {
      this.activeIndex = val;
      this.inputusername = "";
      this.inputpassword = "";
      this.inputmobilphone = "";
      this.inputIdecode = "";
      this.inputpasswordagain = "";
      this.inputdepartment = "";
    },
  }
};
</script>
<style lang="scss" scoped>

.has-vertical-scrollerbar {
  overflow: hidden;
  overflow-y: scroll;

  .el-menu {
    border: 0 none;
    //min-height: 760px;
    padding-bottom: 80px;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
    border-radius: 12px;
  }
}

.has-vertical-scrollerbar::-webkit-scrollbar-track-piece,
.has-vertical-scrollerbar::-webkit-scrollbar {
  width: 0;
}

.is-active {
  /*font-size:16px;*/
  /*color:#000;*/
  /*font-weight:bold;*/
}

.inputidecode {
  .el-input__inner {
    padding-right: 10px;
  }
}

.main-content {
  //position: absolute;
  //left: 220px;
  //right: 0px;
  //top: 0px;
  //bottom: 0;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    display: none;
  }
}

.contain_warp {
  width: 1240px;
  margin: 0 auto;
}

.booter {
  // width: 100%;
  // height: 400px;
  background: url("https://static.dierqudao.com/images/zhigongwang/bg-footer@2x.png");
  background-size: 100%;
  background-position: bottom;
  position: relative;
  padding-top: 400px;

  img {
    width: 100%;
    display: block;
  }

  .booter-box {
    width: 100%;
    height: 180px;
    position: absolute;
    z-index: 2;
    bottom: 0;
    left: 0;

    .booter-info {
      width: 1240px;
      height: 110px;
      margin: 0 auto;

      .footer-danwei {
        font-size: 14px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #ffffff;
        line-height: 21px;
      }

      .link-s {
        font-size: 14px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #ffffff;
        line-height: 21px;
      }
    }

    .booter-bottom {
      width: 100%;
      height: 70px;
      border-top: 1px solid #e5e5e5;
      display: flex;
      justify-content: center;
      align-items: center;

      .booter-bottom-title {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #ffffff;
        margin: 0 25px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// MineLayout.vue?6c9e89e8